/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* AI agent chat request following assistant-ui format
*/
export class SendMessageToAIRequest {
  /**
  * conversation ID
  */
  'id'?: string;
  /**
  * Array of conversation messages
  */
  'messages': Array<any>;
  /**
  * Action trigger type
  */
  'trigger'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "messages",
      "baseName": "messages",
      "type": "Array<any>",
      "format": ""
    },
    {
      "name": "trigger",
      "baseName": "trigger",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SendMessageToAIRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

